import * as React from "react";
import { LinkObject } from "@teamprevent/common/model";
import { Button, DropdownItemProps, Form, DropdownProps, Loader } from "semantic-ui-react";

export interface AssociateOption {
    id: string;
    name: string;
    email: string;
}

interface OwnProps {
    label: string;
    noDataMessage: string;
    managers: LinkObject[] | undefined;
    editable: boolean;
    associateOptions?: AssociateOption[];
    onSave: (selectedIds: { name: string; id: string }[]) => void;
    isLoading: boolean;
}

interface State {
    isEditing: boolean;
    selectedIds: string[];
    options?: DropdownItemProps[];
    isSaving: boolean;
}

export class AssociatedManagersEditor extends React.Component<OwnProps, State> {
    constructor(props: OwnProps) {
        super(props);
        this.state = { isEditing: false, selectedIds: (props.managers || []).map(m => m.id), isSaving: false };
        this.onCancel = this.onCancel.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onEdit = this.onEdit.bind(this);
    }

    public componentDidUpdate(prevProps: OwnProps) {
        if (this.props.managers !== prevProps.managers) {
            this.setState({ selectedIds: (this.props.managers || []).map(m => m.id) });
        }
    }

    public render() {
        if (this.state.isEditing) {
            return (
                <>
                    {this.props.label}
                    <Form>
                        <Form.Group inline>
                            <Form.Select
                                search={true}
                                multiple
                                options={this.state.options || (this.props.managers || []).map(m => ({ key: m.id, value: m.name }))}
                                value={this.state.selectedIds}
                                onChange={this.onSelectChange}
                                loading={this.props.isLoading}
                            />
                            <Form.Button secondary content="Cancel" size="mini" type="button" onClick={this.onCancel} />
                            <Form.Button content="Save" size="mini" onClick={this.onSubmit} type="button" loading={this.state.isSaving} />
                        </Form.Group>
                    </Form>
                </>);
        }

        return (
            <>
                <span>{this.props.label} {this.props.editable && <Button
                    circular
                    icon="edit"
                    secondary
                    size="mini"
                    title="Change managers"
                    onClick={this.onEdit}
                /> }
                </span>
                {!this.props.isLoading ?
                    <>
                        {
                            this.props.managers && this.props.managers.length ?
                                <h3 className="managers">{this.props.managers
                                    .map(s =>
                                        (this.props.associateOptions?.length > 0 ?
                                            this.props.associateOptions.find(o => o.id === s.id)?.email
                                            : null)
                                    || s.name)
                                    .join(", ")}</h3> :
                                <p>{this.props.noDataMessage}</p>
                        }
                    </> :
                    <Loader active={this.props.isLoading} />
                }
            </>);
    }

    public onCancel() {
        this.setState({ isEditing: false, selectedIds: (this.props.managers || []).map(m => m.id) });
    }

    public async onSubmit() {
        this.setState({ isSaving: true });
        try {
            await this.props.onSave(this.state.selectedIds.map(id => ({
                id,
                name: this.props.associateOptions.find(o => o.id === id).name as string
            })));
            this.setState({ isEditing: false, isSaving: false });
        } catch (e) {
            this.setState({ isSaving: false });
            throw e;
        }
    }

    public async onEdit() {
        const options = this.props.associateOptions.map(m => ({ value: m.id, text: m.email }));
        this.setState({ isEditing: true, options });
    }

    private onSelectChange = (e: React.SyntheticEvent<HTMLElement, Event>, d: DropdownProps) => this.setState({ selectedIds: d.value as string[] });
}
